// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"64e46a09","453":"e65f2ebd","667":"2dd52eef"}[chunkId] + ".chunk.js";
};